import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/ai/AI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/breakpointTable/BreakpointTable.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/callout/Callout.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/componentExample/ComponentExample.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/componentExample/ComponentPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/composedComponents/composedComponents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/dosAndDonts/DosAndDonts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/expand/Expand.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/figure/figure.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/motionPreview/MotionPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/overview/Overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHeader"] */ "/opt/build/repo/apps/docs/app/ui/components/pageHeader/PageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/pre/Pre.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/PromptSnippet/PromptSnippet.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/propsReferenceTable/propsReferenceTable.css");
;
import(/* webpackMode: "eager", webpackExports: ["PropTableCodeExample"] */ "/opt/build/repo/apps/docs/app/ui/components/propTable/PropTableCodeExample.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropTableRender"] */ "/opt/build/repo/apps/docs/app/ui/components/propTable/PropTableRender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/components/simpleTable/SimpleTable.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/tabs/Tabs.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/title/title.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/propTable/propTable.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/migrateGuide/migrate-guide.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/card/card.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/icons/iconTable/IconTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/icons/switcher/Switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/layout/aside/Aside.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/layout/subHeader/SubHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/tokens/table/TokenTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/tokens/table/TypographyTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/tokens/table/TypographyVariantTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/tokens/tableSection/TableSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/components/code/code.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/cardLink/cardLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/cardLink/cardLinkList.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/image/image.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/footnote/footnote.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/components/tag/tag.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/tokens/table/tokenTable.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/components/collapsible/Collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/components/highlightCode/HighlightCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/components/link/Link.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/components/table/Table.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
